// Marketing Website API
export const WEBSITE_API_BASE_ENDPOINT = () => {
  const isDev = window && window.location.host.includes('localhost');
  const isPre = window && window.location.host.includes('netlify.app');
  const endpoint = (isDev || isPre) ? 'https://qa-www.marops.affinipay.com' : 'https://www.marops.affinipay.com';
  return endpoint;
};

export const MARKETO_INSTANCE_ID = '433-TWV-220';

export const REGEX_ALLOWED_COOKIE_PREFIX = /^(_fbp|_g|_mkto_trk)+/;
export const REGEX_ALPHA_ONLY = /^[a-zA-Z\s]+$/;
export const REGEX_NUMERIC_ONLY = /^[0-9]+$/;
export const REGEX_EMAIL_ADDRESS = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_PHONE_NUMBER = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
export const REGEX_GUID = /([a-z0-9]{8})-([a-z0-9]{4})-([a-z0-9]{4})-([a-z0-9]{4})-([a-z0-9]{12})/;

const MarOpsConstants = {
  WEBSITE_API_BASE_ENDPOINT,
  REGEX_ALLOWED_COOKIE_PREFIX,
  REGEX_ALPHA_ONLY,
  REGEX_NUMERIC_ONLY,
  REGEX_EMAIL_ADDRESS,
  REGEX_PHONE_NUMBER,
  REGEX_GUID,
  MARKETO_INSTANCE_ID,
};

export default MarOpsConstants;
